import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer, ViewChild, ViewChildren } from '@angular/core';
import { ConcordanceComponent } from 'app/concordance/concordance.component';
import { DataTable } from 'primeng/primeng';
import { Subscription } from 'rxjs';
import { SpeakerService } from '../speaker.service';
import { Chart } from 'chart.js';
import ErrorBarsPlugin from 'chartjs-plugin-error-bars';
import tooltip = L.tooltip;

@Component({
	selector: 'writing',
	templateUrl: './writing.component.html',
	styleUrls: ['./writing.component.css']
})
export class WritingComponent implements OnInit {
	@ViewChild('bar') bar: ElementRef;

	@Output() onChartClick = new EventEmitter();

	@Input() instances: any[];
	@ViewChildren('cbx') checkboxes;
	@ViewChild('dt') dt: DataTable;
	@ViewChild('concordances') concordances: ElementRef;

	selected = [];
	speaker_ids = [];

	genre: boolean = false;

	concordanceGenreFilterSubscription: Subscription;
	concordanceCount = 10;

	// PLOT DATA VARIABLE
	plotData;

	labels: string[] = ['Speech', 'Elanguage', 'Fiction', 'Magazines', 'Newspapers', 'Academic'];

	// DATA OPTIONS
	options = {
		legend: {
			display: false
		},
		plugins: {
			chartJsPluginErrorBars: {
				color: 'rgba(0, 0, 0, 0.1)',
				width: '5%'
			}
		},
		plugin: [ErrorBarsPlugin],
		scales: {
			yAxes: [{
				ticks: {
					min: 0,
					max: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Relative Frequency per 10,000'
				}
			}],
			xAxes: [{
				barPercentage: 8,
				categoryPercentage: 0.1,
				ticks: {
					callback: (value, index, values) => {
						return value;
					}
				}
			}]
		},
		tooltips: {
			enabled: true,
			mode: 'single',
			displayColors: false,
			callbacks: {
				title: function (tooltipItem, data) {
					let labels = ['Speech', 'Elanguage', 'Fiction', 'Magazines', 'Newspapers', 'Academic'];
					return labels[tooltipItem[0].index];
				},
				label: function (tooltipItem, data) {
					let datasetLabel = Number(data.datasets[0].data[tooltipItem.index]);
					let count = Number(data.datasets[0].counts[tooltipItem.index]);
					if (datasetLabel != 0) {
						let i = 2;
						while (Number(d3.format(',.0' + i + 'f')(datasetLabel).replace(",", "")) == 0) {
							i++;
						}
						return d3.format(',.0' + i + 'f')(datasetLabel) + " (" + count + ")";
					}
					return d3.format(',.02f')(datasetLabel) + " (" + count + ")";
				}
			}
		}
	};


	public barChartOptions: any = {
		scaleShowVerticalLines: false,
		responsive: true
	};

	public barChartLabels: string[] = [];
	public barChartType: string = 'bar';
	public barChartLegend: boolean = true;
	public barColors: any[];

	ngOnInit(): void {
		this.speaker.statsChange.subscribe(stats => { this.update(stats); });
		this.barColors = [];

		let ctx = this.bar.nativeElement.getContext('2d');

		let grad1 = ctx.createLinearGradient(0, 0, 0, 200);
		grad1.addColorStop(0, 'rgb(233,105,210)');
		grad1.addColorStop(1, 'rgb(247,126,151)');

		this.barColors.push({ backgroundColor: grad1, hoverBackgroundColor: grad1 });

		let self: WritingComponent = this;
		this.updateConcordanceCount({});
		this.concordanceGenreFilterSubscription = this.speaker.concordanceGenreFilter.subscribe(event => {
			if (event.element) {
				this.speaker.concordanceClearFilter.next({});
				setTimeout(() => {
					self.dt.filter(event.element._model.datasetLabel, 'concordance.genre', 'equals');
				}, 100);
				self.speaker.concordanceGenreFilter.next({});
			}
		});
	}

	getStandardError(array) {
		const n = array.length;

		if (n == 0)
			return 0;

		const mean = array.reduce((a, b) => a + b) / n
		return Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n ** 2)
	}

	update(stats) {
		let genres = ['spoken', 'elanguage', 'fiction', 'magazines', 'newspapers', 'academic'];

		this.plotData = [{ data: [], errorBars: {}, counts: [] }];

		for (let i = 0; i < genres.length; i++) {
			let standard_deviation = 10000 * this.getStandardError(stats['writing']['statistics'][genres[i]]);
			let value = 10000 * stats['writing']['matches'][genres[i]] / stats['writing']['total'][genres[i]];

			this.plotData[0].errorBars[this.labels[i]] = { plus: standard_deviation, minus: -standard_deviation };
			this.plotData[0].counts.push(stats['writing']['matches'][genres[i]]);
			this.plotData[0].data.push(value);

			let max_value = this.roundUp(value + standard_deviation)

			if (max_value > this.options.scales.yAxes[0].ticks.max)
				this.options.scales.yAxes[0].ticks.max = max_value;
		}
	}

	public chartClicked(event: any) {
		if (event.active.length > 0) {
			let chartElement = event.active[0]._chart.getElementAtEvent(event.event);
			console.log(chartElement[0]._model.label);

			if (chartElement[0]._model.label == "Speech") {
				this.speaker.changeView('Concordance', event);
				return;
			}

			let newEvent = {
				element: {
					_model: {
						datasetLabel: chartElement[0]._model.label,
						label: chartElement[0]._model.label
					}
				}
			};
			this.speaker.concordanceGenreFilter.next(newEvent);
			this.genre = true;

			this.concordances.nativeElement.scrollIntoView();
		}
	}

	constructor(private speaker: SpeakerService, private renderer: Renderer) {
		let self: WritingComponent = this;
		speaker.instanceChange.subscribe((res) => {
			self.updateConcordanceCount({});
		});
	}

	toggleErrors() {
		this.options.plugins.chartJsPluginErrorBars.width = "0%";
	}

	ngOnDestroy() {
		if (this.concordanceGenreFilterSubscription)
			this.concordanceGenreFilterSubscription.unsubscribe();
	}
	/*
	  ngOnChanges() {
	  }
	*/
	switchInstance(event) {
		// this.speaker.switchInstance(this.cTable.first, event.data, event.originalEvent.checked);
	}

	switchInstances(event) {
		// this.speaker.switchInstances(event.checked);
	}

	exportCSV(dt) {
		let originalConc = [];
		let self = this;
		dt.value.forEach(row => {
			originalConc.push({ r: row.concordance, left: row.concordance.leftDisplay, right: row.concordance.rightDisplay });
			row.concordance.leftDisplay = self.stripHTML(row.concordance.leftDisplay);
			row.concordance.rightDisplay = self.stripHTML(row.concordance.rightDisplay);
		});

		dt.exportCSV();

		originalConc.forEach(conc => {
			conc.r.leftDisplay = conc.left;
			conc.r.rightDisplay = conc.right;
		});
	}

	stripHTML(s: string) {
		let str = "";
		let insideTag = false;
		for (let i = 0; i < s.length; i++) {
			if (s.charAt(i) == '<')
				insideTag = true;

			if (s.charAt(i) == '>') {
				insideTag = false;
				continue;
			}

			if (!insideTag)
				str += s.charAt(i);
		}
		return str;
	}

	updateConcordanceCount(event) {
		this.speaker.instancesWriting.map(inst => {
			let left = inst['concordance']['left'],
				right = inst['concordance']['right'];
			let leftRemvl = left.length - this.concordanceCount;
			if (leftRemvl >= 0) {
				inst['concordance']['leftDisplay'] = this.buildDisplay(left.slice(left.length - this.concordanceCount), true);
			} else {
				inst['concordance']['leftDisplay'] = this.buildDisplay(left, true);
			}
			inst['concordance']['rightDisplay'] = this.buildDisplay(right.slice(0, this.concordanceCount), false);
		});
	}

	printSpeaker(event) {
		console.log(event);
	}

	roundUp(value) {
		let multiplier = Math.pow(10, Math.floor(Math.log10(value)));
		return Math.ceil(value / multiplier) * multiplier;
	}

	buildDisplay(concArray, isLHS) {
		if (concArray.length == 0) {
			return "";
		}
		let display = "";
		let isTarget;
		if (isLHS)
			isTarget = concArray[0].type == "ntrgt" ? true : false;
		else
			isTarget = concArray[0].type == "ntrgt" ? false : true;
		for (let i = 0; i < concArray.length; i++) {
			if (concArray[i].type == "ntrgt") {
				if (isTarget) {
					if (this.concordanceCount != 100 && i == 0)
						display += "<font color='blue'>" + concArray[i].ele + "</font> ";
					else
						display += "<font color='blue'>S: " + concArray[i].ele + "</font> ";
					isTarget = false;
				} else if (!isLHS && i == 0) {
					display += "<font color='blue'>S: " + concArray[i].ele + "</font> ";
				} else {
					display += "<font color='blue'>" + concArray[i].ele + "</font> ";
				}
			} else if (concArray[i].type == "trgt") {
				if (isTarget) {
					display += "<font color='black'>" + concArray[i].ele + "</font> ";
				} else if (this.concordanceCount != 100 && i == 0) {
					display += "<font color='black'>" + concArray[i].ele + "</font> ";
				} else {
					display += "<font color='black'>S: " + concArray[i].ele + "</font> ";
					isTarget = true;
				}
			}
		}
		return display.substring(0, display.length - 1);
	}

	concordanceSort(event, leftSort) {
		this.speaker.instancesWriting = [...this.speaker.instancesWriting.sort(function (a, b): number {
			let first;
			let second;
			if (leftSort) {
				first = a.concordance.left;
				second = b.concordance.left;
				let first_i = first.length - 1;
				let second_i = second.length - 1;
				while (first_i > -1 && second_i > -1) {
					let cmp = first[first_i].ele.localeCompare(second[second_i].ele);
					if (cmp < 0) {
						return -1 * event.order;
					} else if (cmp > 0) {
						return 1 * event.order;
					}
					first_i--;
					second_i--;
				}
				if (first_i < second_i) {
					return -1 * event.order;
				} else if (first_i > second_i) {
					return 1 * event.order;
				}
				return 0;
			} else {
				first = a.concordance.right;
				second = b.concordance.right;
				let first_i = 0;
				let second_i = 0;
				while (first_i < first.length && second_i < second.length) {
					let cmp = first[first_i].ele.localeCompare(second[second_i].ele);
					if (cmp < 0) {
						return -1 * event.order;
					} else if (cmp > 0) {
						return 1 * event.order;
					}
					first_i++;
					second_i++;
				}
				if (first.length < second.length) {
					return -1 * event.order;
				} else if (first.length > second.length) {
					return 1 * event.order;
				}
				return 0;
			}
		})];
	}
}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/writing/writing.component.ts